module.exports = __webpack_public_path__ + "img/google-play-badge@3x.ad03a4d6.png";